import { useDispatch } from "react-redux";
import { AppDispatch } from "src/types";

export const useAppDispatch: () => AppDispatch = useDispatch;
